export default {
  "cgu": {
    "heroTitle": "Terms & Conditions of Use",
    "lastUpdated": "Last updated: August 3, 2026",
    "sections": [
      {
        "title": "1. Preamble",
        "paragraphs": [
          "These Terms and Conditions of Use (hereinafter \"TCU\") govern access to and use of the website is-telecom.co (hereinafter \"the Site\"), published by IS TELECOM, a company registered in Benin, with its registered office located in Cotonou, Benin.",
          "By accessing the Site and browsing its pages, the user (hereinafter \"the User\") fully and unreservedly accepts these TCU. If the User does not accept these terms, they are asked not to use the Site."
        ]
      },
      {
        "title": "2. Purpose of the Site",
        "paragraphs": ["The Site aims to present the activities, services and products offered by IS TELECOM in the following areas:"],
        "list": [
          "Photovoltaic microgrids and rural electrification",
          "Solar pumping and irrigation solutions",
          "Energy storage and lithium batteries",
          "Electric vehicle charging",
          "Metal construction and civil engineering",
          "IT, networks and monitoring systems",
          "Energy audit and consulting",
          "Telecommunications and infrastructure",
          "Transport and logistics"
        ],
        "paragraphsAfter": [
          "The Site also allows Users to request a quote, contact IS TELECOM and view information about projects completed by the company."
        ]
      },
      {
        "title": "3. Access to the Site",
        "paragraphs": [
          "Access to the Site is free and open to any User with an internet connection. IS TELECOM implements the necessary means to ensure the availability of the Site 24 hours a day, 7 days a week, except in cases of force majeure, technical maintenance or updates requiring temporary interruption.",
          "IS TELECOM reserves the right to modify, suspend or interrupt access to the Site, in whole or in part, without notice and without giving rise to any compensation."
        ]
      },
      {
        "title": "4. Intellectual Property",
        "paragraphs": [
          "All elements comprising the Site (texts, graphics, logos, icons, images, videos, sounds, software, databases, etc.) are the exclusive property of IS TELECOM or its partners and are protected by intellectual property laws.",
          "Any reproduction, representation, modification, publication, adaptation or exploitation, in whole or in part, of the Site's elements, by any means whatsoever, without the prior written authorization of IS TELECOM, is strictly prohibited and constitutes infringement."
        ]
      },
      {
        "title": "5. Use of the Site",
        "paragraphs": ["The User agrees to use the Site fairly and in accordance with its purpose. The User is notably prohibited from:"],
        "list": [
          "Using the Site for illegal or fraudulent purposes",
          "Introducing viruses, Trojan horses, worms or any other malicious software",
          "Disrupting or interrupting access to the Site or its servers",
          "Collecting personal data of other Users without their consent",
          "Disseminating defamatory, insulting, obscene or public order-offending content"
        ]
      },
      {
        "title": "6. Hyperlinks",
        "paragraphs": [
          "The Site may contain links to third-party websites. IS TELECOM exercises no control over the content of these sites and declines all responsibility for their content, accuracy or operation. Activation of these links is the sole responsibility of the User.",
          "Any creation of a hyperlink to the Site must be subject to prior written authorization from IS TELECOM. IS TELECOM reserves the right to request the removal of any unauthorized link."
        ]
      },
      {
        "title": "7. Liability",
        "paragraphs": [
          "IS TELECOM strives to ensure the accuracy and updating of the information published on the Site. However, IS TELECOM cannot guarantee the completeness, accuracy or absence of errors in the information provided. The User is invited to verify the accuracy of information with IS TELECOM before making any decision.",
          "IS TELECOM cannot be held liable for direct or indirect damages resulting from the use of the Site, the impossibility of accessing it, or the consultation of content from linked sites."
        ]
      },
      {
        "title": "8. Personal Data",
        "paragraphs": [
          "IS TELECOM collects and processes Users' personal data in accordance with its Privacy Policy, accessible on the Site. The User is invited to consult this policy to understand how their data is collected, used and protected."
        ]
      },
      {
        "title": "9. Cookies",
        "paragraphs": [
          "The Site uses cookies and similar technologies to improve browsing experience, analyze traffic and personalize content. The User can manage their cookie preferences via their browser settings."
        ]
      },
      {
        "title": "10. Modification of the TCU",
        "paragraphs": [
          "IS TELECOM reserves the right to modify these TCU at any time, notably to adapt to legal, regulatory or technical developments. Modifications take effect upon their publication on the Site. The User is invited to regularly consult the TCU to be aware of any modifications."
        ]
      },
      {
        "title": "11. Applicable Law and Jurisdiction",
        "paragraphs": [
          "These TCU are governed by Beninese law. In the event of a dispute relating to the interpretation, execution or validity of these TCU, the parties undertake to seek an amicable solution before any legal action. Failing an amicable agreement, the competent courts of Cotonou, Benin, shall have exclusive jurisdiction."
        ]
      },
      {
        "title": "12. Contact",
        "paragraphs": [
          "For any questions relating to these TCU or the operation of the Site, the User may contact IS TELECOM at the following address:"
        ]
      }
    ]
  }
};